import { fetchApi } from '@/utils/axios'
import { DownloadResult, CustomizationData, UserMobileInfoParams, UserMobileInfoResponse,
  GetSmsCodeParams, VerifySmsCodeParams, SystemMessage
} from './types'

export const downloadUrlAPi = () => {
  return fetchApi<DownloadResult>({
    url: '/common_file/getDownloadUrl',
    method: 'get',
    noToken: true
  })
}

// 定制化配置
export const getCustomizationData = () => {
  return new Promise<CustomizationData>((resolve, reject) => {
    let storage = localStorage.getItem('customization')
    if (storage) {
      localStorage.removeItem('customization')
    }
    return fetchApi<CustomizationData>({
      url: '/common/customization',
      method: 'get',
      noToken: true
    }).then(res => {
      if (res) {
        localStorage.setItem('customization', JSON.stringify(res))
        resolve(res)
      }
    }).catch(err => {
      reject(err)
    })
  })
}

// 查询手机
export const getUserMobileApi = (params: UserMobileInfoParams) => {
  const { enterpriseAccount, account } = params
  return fetchApi<UserMobileInfoResponse>({
    url: `/users/mobile/${enterpriseAccount}/${account}`,
    method: 'get',
    noToken: true
  })
}

// 根据手机号获取验证码
export const getSMSVerificationCodeApi = (params: GetSmsCodeParams) => {
  return fetchApi({
    url: '/captcha/sms',
    method: 'get',
    params,
    noToken: true
  })
}

// 校验短信验证码
export const checkSMSVerificationCodeApi = (params: VerifySmsCodeParams) => {
  return fetchApi({
    url: '/captcha/sms',
    method: 'post',
    params,
    noToken: true
  })
}

// 获取系统维护通知
export const getSystemMessage = () => {
  return fetchApi<SystemMessage>({
    url: '/notification/maintain_message',
    method: 'get',
    noToken: true
  })
}
